import { render, staticRenderFns } from "./ExpressCompose.vue?vue&type=template&id=6b559750&scoped=true&"
import script from "./ExpressCompose.vue?vue&type=script&lang=js&"
export * from "./ExpressCompose.vue?vue&type=script&lang=js&"
import style0 from "./ExpressCompose.vue?vue&type=style&index=0&id=6b559750&lang=scss&scoped=true&"
import style1 from "./ExpressCompose.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b559750",
  null
  
)

export default component.exports